import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const PropsTable = makeShortcode("PropsTable");
const PropsTableSxRow = makeShortcode("PropsTableSxRow");
const PropsTableRow = makeShortcode("PropsTableRow");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Note variant="warning" mdxType="Note">Not implemented yet</Note>
    <h2>{`Examples`}</h2>
    <h3>{`Default`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<SplitPageLayout>
  <SplitPageLayout.Header>
    <Placeholder label="Header" height={64} />
  </SplitPageLayout.Header>
  <SplitPageLayout.Pane>
    <Placeholder label="Pane" height={120} />
  </SplitPageLayout.Pane>
  <SplitPageLayout.Content>
    <Placeholder label="Content" height={240} />
  </SplitPageLayout.Content>
  <SplitPageLayout.Footer>
    <Placeholder label="Footer" height={64} />
  </SplitPageLayout.Footer>
</SplitPageLayout>
`}</code></pre>
    <h3>{`With pane hidden on narrow viewports`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<SplitPageLayout>
  <SplitPageLayout.Header>
    <Placeholder label="Header" height={64} />
  </SplitPageLayout.Header>
  <SplitPageLayout.Pane hidden={{narrow: true}}>
    <Placeholder label="Pane" height={120} />
  </SplitPageLayout.Pane>
  <SplitPageLayout.Content>
    <Placeholder label="Content" height={240} />
  </SplitPageLayout.Content>
  <SplitPageLayout.Footer>
    <Placeholder label="Footer" height={64} />
  </SplitPageLayout.Footer>
</SplitPageLayout>
`}</code></pre>
    <h3>{`With content hidden on narrow viewports`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<SplitPageLayout>
  <SplitPageLayout.Header>
    <Placeholder label="Header" height={64} />
  </SplitPageLayout.Header>
  <SplitPageLayout.Pane>
    <Placeholder label="Pane" height={120} />
  </SplitPageLayout.Pane>
  <SplitPageLayout.Content hidden={{narrow: true}}>
    <Placeholder label="Content" height={240} />
  </SplitPageLayout.Content>
  <SplitPageLayout.Footer>
    <Placeholder label="Footer" height={64} />
  </SplitPageLayout.Footer>
</SplitPageLayout>
`}</code></pre>
    <h3>{`Without dividers`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<SplitPageLayout>
  <SplitPageLayout.Header divider="none">
    <Placeholder label="Header" height={64} />
  </SplitPageLayout.Header>
  <SplitPageLayout.Pane divider="none">
    <Placeholder label="Pane" height={120} />
  </SplitPageLayout.Pane>
  <SplitPageLayout.Content>
    <Placeholder label="Content" height={240} />
  </SplitPageLayout.Content>
  <SplitPageLayout.Footer divider="none">
    <Placeholder label="Footer" height={64} />
  </SplitPageLayout.Footer>
</SplitPageLayout>
`}</code></pre>
    <h3>{`With pane on right`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<SplitPageLayout>
  <SplitPageLayout.Header>
    <Placeholder label="Header" height={64} />
  </SplitPageLayout.Header>
  <SplitPageLayout.Content>
    <Placeholder label="Content" height={240} />
  </SplitPageLayout.Content>
  <SplitPageLayout.Pane position="end">
    <Placeholder label="Pane" height={120} />
  </SplitPageLayout.Pane>
  <SplitPageLayout.Footer>
    <Placeholder label="Footer" height={64} />
  </SplitPageLayout.Footer>
</SplitPageLayout>
`}</code></pre>
    <h3>{`Without padding`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<SplitPageLayout>
  <SplitPageLayout.Header padding="none">
    <Placeholder label="Header" height={64} />
  </SplitPageLayout.Header>
  <SplitPageLayout.Pane padding="none">
    <Placeholder label="Pane" height={120} />
  </SplitPageLayout.Pane>
  <SplitPageLayout.Content padding="none">
    <Placeholder label="Content" height={240} />
  </SplitPageLayout.Content>
  <SplitPageLayout.Footer padding="none">
    <Placeholder label="Footer" height={64} />
  </SplitPageLayout.Footer>
</SplitPageLayout>
`}</code></pre>
    <h3>{`Without header or footer`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<SplitPageLayout>
  <SplitPageLayout.Pane>
    <Placeholder label="Pane" height={120} />
  </SplitPageLayout.Pane>
  <SplitPageLayout.Content>
    <Placeholder label="Content" height={240} />
  </SplitPageLayout.Content>
</SplitPageLayout>
`}</code></pre>
    <h3>{`With non-sticky pane`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<SplitPageLayout>
  <SplitPageLayout.Header>
    <Placeholder label="Header" height={64} />
  </SplitPageLayout.Header>
  <SplitPageLayout.Pane sticky={false}>
    <Placeholder label="Pane" height={120} />
  </SplitPageLayout.Pane>
  <SplitPageLayout.Content>
    <Placeholder label="Content" height={240} />
  </SplitPageLayout.Content>
  <SplitPageLayout.Footer>
    <Placeholder label="Footer" height={64} />
  </SplitPageLayout.Footer>
</SplitPageLayout>
`}</code></pre>
    <h2>{`Props`}</h2>
    <h3>{`SplitPageLayout`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h3>{`SplitPageLayout.Header`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="divider" // TODO: Document ResponsiveValue
      // This prop accepts a viewport range map (i.e. {regular: ..., narrow: ...}) in addition to a single value.
      // The `regular` and `wide` keys of the viewport range map can be 'none' or 'line'.
      // The `narrow` key of the viewport range map can be 'none' or 'line' or 'filled'.
      type={`ResponsiveValue<
  'none' | 'line',
  'none' | 'line' | 'filled'
>`} defaultValue="'line'" mdxType="PropsTableRow" />
  <PropsTableRow name="hidden" type={`ResponsiveValue<boolean>`} defaultValue="false" description="Whether the header is hidden." mdxType="PropsTableRow" />
  <PropsTableRow name="padding" type={`| 'none'
| 'normal'
| 'condensed'`} defaultValue="'normal'" mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h3>{`SplitPageLayout.Content`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="width" type={`| 'full'
| 'medium'
| 'large'
| 'xlarge'`} defaultValue="'xlarge'" description="The maximum width of the content region." mdxType="PropsTableRow" />
  <PropsTableRow name="hidden" type={`ResponsiveValue<boolean>`} defaultValue="false" description="Whether the content is hidden." mdxType="PropsTableRow" />
  <PropsTableRow name="padding" type={`| 'none'
| 'normal'
| 'condensed'`} defaultValue="'normal'" mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h3>{`SplitPageLayout.Pane`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="position" type={`ResponsiveValue<
  'start' | 'end'
>`} defaultValue="'start'" mdxType="PropsTableRow" />
  <PropsTableRow name="width" type={`| 'small'
| 'medium'
| 'large'`} defaultValue="'medium'" description="The width of the pane." mdxType="PropsTableRow" />
  <PropsTableRow name="divider" type={`ResponsiveValue<
  'none' | 'line',
  'none' | 'line' | 'filled'
>`} defaultValue="'line'" mdxType="PropsTableRow" />
  <PropsTableRow name="hidden" type={`ResponsiveValue<boolean>`} defaultValue="false" description="Whether the pane is hidden." mdxType="PropsTableRow" />
  <PropsTableRow name="padding" type={`| 'none'
| 'normal'
| 'condensed'`} defaultValue="'normal'" mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h3>{`SplitPageLayout.Footer`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="divider" type={`ResponsiveValue<
  'none' | 'line',
  'none' | 'line' | 'filled'
>`} defaultValue="'line'" mdxType="PropsTableRow" />
  <PropsTableRow name="hidden" type={`ResponsiveValue<boolean>`} defaultValue="false" description="Whether the footer is hidden." mdxType="PropsTableRow" />
  <PropsTableRow name="padding" type={`| 'none'
| 'normal'
| 'condensed'`} defaultValue="'normal'" mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: false,
      adaptsToThemes: false,
      adaptsToScreenSizes: false,
      fullTestCoverage: false,
      usedInProduction: false,
      usageExamplesDocumented: false,
      hasStorybookStories: false,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      